import { useEffect, useMemo, useState } from 'react';
import type { Connection } from '@bentley/pw-wac';
import { useWorkAreaConnections } from '@bentley/pw-wac';
import { useConfigContext, useOidcContext } from '../../../context';
import { readUniversalLinkParams } from '../searchParams/searchParams';
import { parseDefaultTabHref } from './parseDefaultTab';

export function useTeamsLink(): string {
  const { config } = useConfigContext();
  const { getOidcToken } = useOidcContext();

  const { datasource, workAreaId, projectId } = readUniversalLinkParams();

  const [connections, setConnections] = useState<Connection[]>([]);

  const { initialized, getAll } = useWorkAreaConnections({
    buddiRegionCode: config.BUDDIRegionCode,
    contextId: projectId ?? '',
    getOidcToken
  });

  const selectedConnection = useMemo((): Connection | undefined => {
    if (!connections.length) {
      return undefined;
    }

    const selectedConnection = connections.find(
      (connection) =>
        connection.DatasourceId == datasource &&
        connection.ProjectId == workAreaId
    );
    return selectedConnection;
  }, [datasource, connections, workAreaId]);

  const teamsLink = useMemo((): string => {
    if (!selectedConnection?.DefaultTab) {
      return '';
    }

    const teamsLink = parseDefaultTabHref(selectedConnection);
    return teamsLink;
  }, [selectedConnection]);

  useEffect(() => {
    async function loadConnections(): Promise<void> {
      const connections = await getAll();
      setConnections(connections);
    }

    if (!initialized) {
      return;
    }

    void loadConnections();
  }, [initialized, getAll]);

  return teamsLink;
}
